import Modal, { DisplayModal } from "./Modal";
import { ModalTypes } from "../../types/enums";

const OverlayModal = () => <Modal allowClickOutside={false}><div></div></Modal>;

export default DisplayModal(OverlayModal, ModalTypes.OVERLAY);